export default function checkPwa() {
  try {
    const isInstalled =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    return isInstalled;
  } catch (error) {}
  return false;
}
